export default {
  id: 76,
  title: 'Target #76 - Beeee',
  url: 'https://cssbattle.dev/play/76',
  colors: ['#998235', '#FFFFFF', '#EFF33C', '#191919'],
  solution:
    '<a a><a b><style>[a],[b]{left:125;height:75}body{background:#998235}a{position:fixed;border-radius:9in}[a]{top:75;width:75;background:#fff;box-shadow:75px 0 #fff,35px 35px #fff}[b]{background:linear-gradient(to right,#191919,#191919 25px,#eff33c 25px,#eff33c 35px,#191919 35px,#191919 60px,#eff33c 60px,#eff33c 70px,#191919 70px,#191919 95px,transparent 95px),radial-gradient(circle at 122.5px 27.5px,#191919 0,#191919 7.5px,#eff33c 7.5px);top:150;width:150}</style>',
}
